import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";

/**
 * Captures a referral code from /r/:code, stores it in localStorage,
 * then bounces the user to the register page (or app if they're already logged in).
 * The RegisterPage reads the code from localStorage and forwards it to the API.
 */
export default function ReferralCapture() {
  const { code } = useParams();

  useEffect(() => {
    if (code) {
      try {
        const normalized = String(code).trim().toUpperCase();
        localStorage.setItem("lazylean_ref_code", normalized);
        localStorage.setItem("lazylean_ref_at", String(Date.now()));
      } catch (e) {
        // localStorage might be blocked — non-fatal, just lose attribution
      }
    }
  }, [code]);

  return <Navigate to="/register" replace />;
}
